import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

// service
import { UsersService } from './../../../data/services/user.service';

// dto
import { UserDetailsDto } from './../../../data/models/dto/user-details.dto';

// components
import { SnackBarComponent } from '../snack-bar/snack-bar.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss']
})
export class UserDetailsComponent implements OnInit, OnDestroy {

  @Output() onClose = new EventEmitter()
  @Input() idUserDetails: string | string[] | undefined

  user: UserDetailsDto | undefined
  showHeader: boolean = false
  loading: boolean = false
  isStudent: boolean = false

  private subscription: Subscription = new Subscription();

  constructor(
    private readonly userService: UsersService,
    private readonly route: ActivatedRoute,
    private readonly snackBar: SnackBarComponent,
  ) {
    this.route.params.subscribe((params: Params) => {
      this.idUserDetails = params['id']

      if (this.idUserDetails)
        this.showHeader = false
      else
        this.showHeader = true
    })
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }

  ngOnInit() {
    if (this.idUserDetails) {
      if (!Array.isArray(this.idUserDetails))
        this.getUserDetails(this.idUserDetails)
      else
        this.getUserDetailsByRoomMembersIds(this.idUserDetails)
    }
  }

  close() {
    this.onClose.emit()
  }


  private getUserDetails(id: string): void {
    this.loading = true
    this.subscription = this.userService.getDetails(id).subscribe(
      (user: UserDetailsDto) => {
        this.loading = false
        this.user = user
        this.isStudent = user.children != null && user.children.length > 0
      },
      (error) => {
        console.log(error);
        this.loading = false
        this.snackBar.openSnackBar('Falha ao obter os detalhes do usuário', 'ok');
      }
    );
  }

  private getUserDetailsByRoomMembersIds(idsUsers: string[]): void {
    this.loading = true

    const ids = idsUsers.join(',')
    this.subscription = this.userService.getDetailsByRoomMembers(ids).subscribe(
      (user: UserDetailsDto) => {
        this.loading = false
        this.user = user
        this.isStudent = user.children != null && user.children.length > 0
      },
      (error) => {
        console.log(error);
        this.loading = false
        this.snackBar.openSnackBar('Falha ao obter os detalhes do usuário', 'ok');
      }
    );
  }
}
